// ─── src/components/dashboard/StatsOverview.tsx ───────────────────────────────
import type { FC } from "react";
import { Users, Lightbulb, Award, UserCheck } from "lucide-react";
import type { RegistrationStatsResponse } from "../../types/stats";
import { StatCard }      from "../ui/StatCard";
import { StatsSkeleton } from "../ui/Skeleton";

interface Props {
  stats:     RegistrationStatsResponse;
  isLoading: boolean;
}

export const StatsOverview: FC<Props> = ({ stats, isLoading }) => {
  if (isLoading) return <StatsSkeleton />;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard icon={Users}     label="Total Applicants"     value={stats.total}                  accent="bg-brand-teal"   />
      <StatCard icon={Lightbulb} label="Pitching Ideas"       value={stats.pitchingIdea}           accent="bg-brand-orange" />
      <StatCard icon={Award}     label="Scholarship Requests" value={stats.requestingScholarship}  accent="bg-indigo-600"   />
      <StatCard icon={UserCheck} label="Available All Days"   value={stats.availableAllDays}       accent="bg-emerald-600"  />
    </div>
  );
};
